export default __webpack_public_path__ + "static/nextGenerationMechanicalBenchtop-c9f56bb8712c4ede5c81976fd323552a.png";